import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import moment from "moment"
import { Tooltip } from "@mui/material"
import { DialogFormTaskSubs } from "../DialogFormTaskSubs"
import { Tasks } from "../../../models/tasks"
import NumberFormat from "react-number-format"
import { Model } from "../../../models/model"
import { getNumberDays } from "../../../helpers/tasks"
import { BoxFlows } from "./BoxFlows"

const statusList = [
    { id: 'por hacer', nombre: 'por hacer' },
    { id: 'en proceso', nombre: 'en proceso' },
    { id: 'completado', nombre: 'completado' },
    { id: 'stand-by', nombre: 'stand-by' }
]

// const priorityList = [
//     { id: 'critica', nombre: 'crítica' },
//     { id: 'alta', nombre: 'alta' },
//     { id: 'media', nombre: 'media' },
//     { id: 'baja', nombre: 'baja' }
// ]

export const DetailSubsTasks = ({ currentTask, opens = null, usuariosTarea, refreshObj, pathName, tarea_mostrar_horas }) => {

    const [listTask, setListTask] = useState(currentTask?.subs || [])
    const [openDialogFormTaskSubs, setOpenDialogFormTaskSubs] = useState(false)
    const [idTaskSubsSelect, setIdTaskSubsSelect] = useState(0)

    useEffect(() => {
        setListTask(currentTask?.subs || [])
    }, [currentTask?.subs])


    const handleOpenEdit_ = (id) => {
        setIdTaskSubsSelect(id)
        setOpenDialogFormTaskSubs(true)
    }

    const handleChangeNumberDays = async (values, item, targetName) => {
        if (!values.sourceInfo.event) return false

        const newStartDate = item?.fecha_inicio ? item?.fecha_inicio : new Date()
        const numberDays = getNumberDays(values.floatValue)
        const newEndDate = moment(newStartDate).add(numberDays, 'days').format('YYYY-MM-DD')

        const newForm = {
            ...item,
            dias: values.floatValue,
            fecha_inicio: newStartDate,
            fecha_fin: newEndDate,
            change_days: true,
            date_change_option: 'esta_tarea_posteriores'
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    dias: values.floatValue,
                    fecha_inicio: newStartDate,
                    fecha_fin: newEndDate
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

        if (refreshObj) {
            const checkOpen = true
            await refreshObj.fn_(refreshObj.filters_, checkOpen)
        }

    }

    const handleChangeTimes = async (values, item, targetName) => {
        if (!values.sourceInfo.event) return false

        const newForm = {
            ...item,
            [targetName]: values.floatValue
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return newForm
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

    }

    const handleRemoveTask_ = async (task) => {
        const tasksListUpdated = listTask?.filter(it => it.id !== task.id)
        setListTask(tasksListUpdated)

        await Model.delete({
            url: `tasks/proyectos/tasks2/${task.id}`
        })
    }

    const handleChangeDateIni = async (newValue, item) => {
        const startDate = newValue.target.value
        const numberDays = getNumberDays(moment(startDate).diff(moment(startDate), 'days'))

        const newForm = {
            ...item,
            dias: numberDays,
            fecha_inicio: startDate,
            fecha_fin: startDate,
            edit_end_date: true,
            change_days: true,
            date_change_option: 'esta_tarea'
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    dias: numberDays,
                    fecha_inicio: startDate,
                    fecha_fin: startDate
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

        if (refreshObj) {
            const checkOpen = true
            await refreshObj.fn_(refreshObj.filters_, checkOpen)
        }

    }

    const handleChangeDateFin = async (newValue, item = null) => {
        const endDate = newValue.target.value
        const startDate = item?.fecha_inicio ? item?.fecha_inicio : endDate
        const numberDays = getNumberDays(moment(endDate).diff(moment(startDate), 'days'))

        const newForm = {
            ...item,
            dias: numberDays,
            fecha_inicio: startDate,
            fecha_fin: endDate,
            edit_end_date: true,
            change_days: true,
            date_change_option: 'esta_tarea'
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    dias: numberDays,
                    fecha_inicio: startDate,
                    fecha_fin: endDate
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

        if (refreshObj) {
            const checkOpen = true
            await refreshObj.fn_(refreshObj.filters_, checkOpen)
        }

    }

    const handleChange = async ({ target }, item) => {

        const newForm = {
            ...item,
            [target.name]: target.value
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    ...newForm
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)
    }

    const handleChangeStatus = async ({ target }, item) => {

        const newForm = {
            ...item,
            [target.name]: target.value,
            change_state: true
        }

        const listUpdated = listTask.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    ...newForm
                }
            }

            return it
        })

        setListTask(listUpdated)
        await Tasks.update(newForm)

        if (refreshObj) {
            const checkOpen = true
            await refreshObj.fn_(refreshObj.filters_, checkOpen)
        }

    }


    return (
        <>

            {openDialogFormTaskSubs &&
                <DialogFormTaskSubs
                    open={openDialogFormTaskSubs}
                    setOpen={setOpenDialogFormTaskSubs}
                    taskId={idTaskSubsSelect || 0}
                    refreshObj={refreshObj}
                />
            }

            {listTask?.map((it, index) => (
                <tr
                    key={`subtasks-${it.id}-${index}`}
                    className="text-center"
                    style={{
                        backgroundColor: '#FCF1FF',
                        color: it.estado === 'completado' ? 'green' : ''
                    }}
                >
                    {pathName === 'tasks' ? <td></td> : ''}
                    <td colSpan={3} className="text-start p-va">
                        {/* <div className="ms-4"> */}
                        <div className="ms-4 d-flex justify-content-between align-items-center">
                            <Link
                                to=""
                                onClick={() => handleOpenEdit_(it?.id)}
                                className={`d-flex justify-content-start align-items-center ms-2 
                                    ${it.estado === 'completado' ? 'p-link-tasks-done' : 'p-link-tasks'}`}
                            >
                                <i className="bi bi-arrow-return-right" style={{ color: '#8E24AA', fontSize: '14px' }}></i>
                                <div
                                    className="ms-1"
                                    style={{
                                        fontSize: '12px',
                                        color: it.estado === 'completado' ? 'green' : '#8E24AA',
                                        textAlign: 'left',
                                        // textDecoration: it.estado === 'completado' ? 'line-through' : ''
                                    }}>
                                    ({it.orden}){' '}{it.nombre}
                                </div>

                                {it.estado === 'completado' ?
                                    <Tooltip title="Tarea completada">
                                        <i className="bi bi-check-circle-fill ms-1" style={{ fontSize: '14px' }}></i>
                                    </Tooltip> : ''
                                }

                            </Link>

                            {it?.info_flow.length > 0 ?
                                <Link
                                    to=""
                                    style={{ marginTop: '2px' }}
                                    className="p-link-hitos ms-2 d-flex justify-content-start align-items-end"
                                    onClick={() => opens.handleOpenEditFlow(it)}
                                >
                                    <span className="d-flex flex-column justify-content-start align-items-end mt-2">
                                        {it?.info_flow.map(itf => <BoxFlows flow={itf} />)}
                                    </span>
                                </Link>
                                :
                                it?.id_proyecto ?
                                    <Link
                                        to=""
                                        style={{ textDecoration: 'none' }}
                                        onClick={() => opens.handleOpenEditFlow(it)}
                                    >
                                        <i className="bi bi-link-45deg" style={{ fontSize: '12px' }}></i>
                                        <span style={{ textTransform: 'none', marginLeft: '2px' }}>Enlazar a flujo</span>
                                    </Link> :
                                    ''
                            }

                        </div>
                    </td>
                    <td className="p-va">
                        <select
                            style={{
                                border: '1px solid lightgray',
                                padding: '2px',
                                backgroundColor: 'white',
                                width: '60px',
                                borderRadius: '3px'
                            }}
                            name="id_responsable"
                            onChange={(e) => handleChange(e, it)}
                        >
                            <option key="" value="">--</option>
                            {usuariosTarea?.map(ut => (
                                <option
                                    key={ut.id}
                                    selected={ut.id === it?.id_responsable ? 'selected' : ''}
                                    value={ut.id}
                                >
                                    {ut.nombre}
                                </option>
                            ))}
                        </select>
                    </td>
                    <td className="p-va">
                        <select
                            style={{
                                border: '1px solid lightgray',
                                padding: '2px',
                                backgroundColor: 'white',
                                width: '60px',
                                borderRadius: '3px'
                            }}
                            name="id_responsable_seguimiento"
                            onChange={(e) => handleChange(e, it)}
                        >
                            <option key="" value="">--</option>
                            {usuariosTarea?.map(ut => (
                                <option
                                    key={ut.id}
                                    selected={ut.id === it?.id_responsable_seguimiento ? 'selected' : ''}
                                    value={ut.id}
                                >
                                    {ut.nombre}
                                </option>
                            ))}
                        </select>
                    </td>

                    {tarea_mostrar_horas ?
                        <>
                            <td>
                                <NumberFormat
                                    className="text-end p-cantidades-item-new22"
                                    style={{ backgroundColor: 'white', width: '80px', height: '21px', borderRadius: '3px' }}
                                    name="hora_estimada"
                                    value={it?.hora_estimada || 0}
                                    thousandSeparator=','
                                    decimalSeparator='.'
                                    suffix=" hrs."
                                    decimalScale={2}
                                    fixedDecimalScale={0}
                                    onValueChange={(values, sourceInfo) => handleChangeTimes({ ...values, sourceInfo }, it, 'hora_estimada')}
                                />
                            </td>
                            <td>
                                <NumberFormat
                                    className="text-end p-cantidades-item-new22"
                                    style={{ backgroundColor: 'white', width: '80px', height: '21px', borderRadius: '3px' }}
                                    name="hora_real"
                                    value={it?.hora_real || 0}
                                    thousandSeparator=','
                                    decimalSeparator='.'
                                    suffix=" hrs."
                                    decimalScale={2}
                                    fixedDecimalScale={0}
                                    onValueChange={(values, sourceInfo) => handleChangeTimes({ ...values, sourceInfo }, it, 'hora_real')}
                                />
                            </td>
                        </>
                        : ''
                    }

                    <td className="p-va">
                        <NumberFormat
                            className="text-end p-cantidades-item-new22"
                            style={{ backgroundColor: 'white', width: '80px', height: '21px', borderRadius: '3px' }}
                            name="dias"
                            value={it.dias || 0}
                            thousandSeparator=','
                            decimalSeparator='.'
                            suffix=" días"
                            decimalScale={0}
                            fixedDecimalScale={0}
                            onValueChange={(values, sourceInfo) => handleChangeNumberDays({ ...values, sourceInfo }, it, 'dias')}
                        />
                    </td>
                    <td className="p-va">
                        <input
                            style={{ padding: '2px', borderRadius: '3px' }}
                            type="date"
                            value={moment(it?.fecha_inicio).format('YYYY-MM-DD')}
                            onChange={(value) => handleChangeDateIni(value, it)}
                        />
                    </td>
                    <td className="p-va">
                        <div className="d-flex justify-content-end align-items-center">
                            <input
                                style={{ padding: '2px', borderRadius: '3px' }}
                                type="date"
                                value={moment(it?.fecha_fin).format('YYYY-MM-DD')}
                                onChange={(value) => handleChangeDateFin(value, it)}
                            />
                        </div>
                    </td>
                    <td className="p-va">
                        {it?.subs?.length > 0 ?
                            <div style={{
                                color: it?.estado === 'completado' ? 'green' : (it?.estado === 'en proceso' ? '#0F7DFF' : '#FFAD0F'),
                                textTransform: 'uppercase',
                                fontSize: '10px'
                            }}>
                                {it?.estado || '--'}
                            </div>
                            :
                            <select
                                style={{
                                    border: '1px solid lightgray',
                                    padding: '2px',
                                    fontSize: '10px',
                                    backgroundColor: 'white',
                                    textTransform: 'uppercase',
                                    borderRadius: '3px',
                                    color: it?.estado === 'completado' ? 'green' : (it?.estado === 'en proceso' ? '#0F7DFF' : '#FFAD0F'),
                                }}
                                name="estado"
                                onChange={(e) => handleChangeStatus(e, it)}
                            >
                                <option key="" value="">--</option>
                                {statusList?.map(es => (
                                    <option
                                        key={es.id}
                                        selected={es.id === it?.estado ? 'selected' : ''}
                                        value={es.id}
                                    >
                                        {es.nombre}
                                    </option>
                                ))}
                            </select>
                        }
                    </td>
                    <td className="p-va">
                        {!it?.info_flow?.id ?
                            < Tooltip title="Eliminar subtarea">
                                <Link to="" onClick={() => handleRemoveTask_(it)}>
                                    <i className="bi bi-trash" style={{ color: 'gray', fontSize: '14px' }}></i>
                                </Link>
                            </Tooltip> : ''
                        }
                    </td>
                </tr >
            ))
            }
        </>

    )
}


// const BoxFlows = ({ flow }) => {
//     return (
//         <span>
//             <span>

//                 {flow?.tipo_flujo === 'ingreso' ?
//                     <i className="bi bi-arrow-up-short" style={{ color: 'green', fontSize: '14px' }}></i>
//                     :
//                     <i className="bi bi-arrow-down-short" style={{ color: 'red', fontSize: '14px' }}></i>
//                 }
//             </span>
//             flujo {flow.tipo_flujo} ( <span className="me-1">{moment(flow?.fecha_proyeccion).format('DD-MM-YYYY')}</span> |
//             <NumberFormat
//                 displayType={'text'}
//                 className="ms-1 me-1"
//                 value={flow?.tipo_flujo === 'ingreso' ?
//                     parseFloat(flow?.monto_neto || 0) :
//                     parseFloat(flow?.total || 0)
//                 }
//                 thousandSeparator={flow?.separacion_miles || ','}
//                 decimalSeparator={flow?.separacion_decimales || '.'}
//                 prefix={`${flow?.simbolo || 'S/ '} `}
//                 decimalScale={2}
//                 fixedDecimalScale={2}
//             />
//             |<span className="ms-1 me-1" title={flow.nombre_completo}>{flow.nombre}...</span>
//             |<span className="ms-1" style={{ color: flow.estado === 'pagada' ? 'green' : '' }}>{flow.estado}</span> )
//         </span>
//     )
// }
